export class Automation {
    automationId: string;
    automationname: string;
    description?: string;
    organizationId: string;
    projectId?: string;
    automationtriggerevent: string; 
    automationtriggercondition: string;
    automationtype: string; // e.g., 'project', 'organization'
    status: string; // e.g., 'active', 'inactive'
    created?: string; // ISO date string
    createdby?: string; // ID of the source from which this automation was created
    lastrun?: any;
}